// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_G1Q","cls2":"RelatedPapers-cls2_DQH RelatedPapers-cls1_G1Q"};